// src/lib/apercu-prelu.js — L'APERÇU DÉJÀ LU PAR LE SERVEUR, REPRIS PAR LA
// CARTE AU LIEU D'ÊTRE RELU.
//
// ══ POURQUOI (2026-09-22) ══════════════════════════════════════════════════
//
// Depuis que l'opérateur dit « cette nuit est déjà vendue » AVANT de poser la
// carte (`lib/operateur-nuit-vendue.js`), le SERVEUR a déjà lu l'aperçu de la
// période pour composer cette phrase. La carte le relisait derrière, au
// montage : deux allers-retours pour le même état, et DEUX JETONS pour une
// seule décision.
//
// ⚠️ ET SUR CE CHEMIN, LE JETON NE PROTÈGE RIEN — DETTE NOMMÉE (revue #1486,
// m1). `jetonApercu` hache les faits affichés, et les écritures qui le
// VÉRIFIENT (booking-decision, factures-envoi, incident-champ, menage-run-
// champ, logement-gallery, taches) refusent en 409 quand l'état a bougé.
// `pricing_set_manual`, LUI, NE LE VÉRIFIE PAS — c'est la dette écrite en tête
// de `lib/pricing-lectures-apercu.js`, pas une garantie de ce module. Ne pas
// laisser croire le contraire : ici, le jeton ne fait que rendre la carte
// cliquable (elle refuse de laisser cliquer sans lui).
//
// Ce que la reprise du pré-lu change vraiment : c'est bien l'état que Dimitri
// a LU qui s'affiche sous son doigt. Relire au dernier moment « par prudence »
// remplacerait en silence ce qu'il a lu par autre chose — et sans 409 pour le
// lui dire, il validerait une carte qu'il n'a jamais vue.
//
// ⚠️ FAIL-CLOSED. Sans jeton, ou si le pré-lu ne porte pas sur le logement de
// la carte, on rend `null` : la carte relit, comme avant ce lot. Mieux vaut un
// aller-retour de plus qu'un « avant » qui vient d'ailleurs.

/**
 * L'aperçu déjà lu, s'il est utilisable tel quel.
 *
 * @param {object} geste — la carte servie (`geste.apercu_prelu` s'il existe)
 * @param {object} decl — la déclaration `apercu` du levier, relue au registre
 * @returns {object|null} la MÊME forme que ce que rendrait la lecture HTTP
 */
function apercuPrelu(geste, decl) {
  const g = geste && typeof geste === "object" ? geste : null;
  if (!g || !decl || typeof decl !== "object") return null;
  const p =
    g.apercu_prelu && typeof g.apercu_prelu === "object"
      ? g.apercu_prelu
      : null;
  if (!p) return null;
  // Défense en profondeur (revue #1486, m2) : le serveur ne pose le pré-lu que
  // sur une lecture réussie, mais un `ok:false` arrivant ici habillerait la
  // carte avec un refus. Une garde d'une ligne coûte moins cher qu'un « avant »
  // composé d'une erreur.
  if (p.ok !== true) return null;
  // La carte refuse de laisser cliquer un aperçu sans jeton : un pré-lu qui
  // n'en porte pas ne servirait qu'à griser le bouton pour toujours.
  if (typeof p.cfg_version !== "string" || !p.cfg_version) return null;
  // Le pré-lu doit porter sur LE logement de la carte. Un geste recomposé
  // avec un autre logement afficherait l'« avant » du précédent.
  const vise = (g.args || {}).logement_id;
  if (vise && p.logement_id && p.logement_id !== vise) return null;
  return p;
}

export default apercuPrelu;
export { apercuPrelu };
